var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid bg-repeat",style:(Object.assign({}, {backgroundImage: _vm.dynamicBgImage}, _vm.styleObject))},[(_vm.isStandardLayout)?_c('Sidebar'):_vm._e(),_c('router-view',{key:_vm.$route.path}),_c('Alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }